const MuiDrawer = {
    styleOverrides: {
        root: ({ theme })=>({
                '.MuiBackdrop-root': {
                    backgroundColor: theme.palette.background.overlay
                }
            }),
        paper: ({ theme })=>{
            const backgroundStyle = 'light' === theme.palette.mode ? {} : {
                backgroundImage: 'unset',
                backgroundColor: theme.palette.designSystem.grey[900]
            };
            return {
                ...backgroundStyle
            };
        }
    }
};
export { MuiDrawer };

//# sourceMappingURL=drawer-overrides.js.map